// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__2H04C","inputWrap":"CustomTip_inputWrap__3n6TK"};